var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H3C2.44772 24 2 24.4477 2 25C2 25.5523 2.44772 26 3 26H24C24.5523 26 25 25.5523 25 25C25 24.4477 24.5523 24 24 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7531 5.46474C18.0507 5.16717 18.4543 5 18.8751 5C19.2959 5 19.6995 5.16717 19.9971 5.46474C20.2947 5.76231 20.4618 6.1659 20.4618 6.58673C20.4618 7.00436 20.2972 7.40503 20.0038 7.70193L19.251 8.42262L17.0074 6.17898L17.7376 5.47998L17.7531 5.46474ZM15.5624 7.56237L7.11953 15.6451L6.37439 18.6256L9.3777 17.8748L17.806 9.80601L15.5624 7.56237ZM18.8751 3C17.9278 3 17.0191 3.37477 16.3473 4.0422L5.52788 14.4001C5.39161 14.5305 5.29503 14.6969 5.24927 14.8799L4.02988 19.7574C3.94468 20.0982 4.04453 20.4587 4.29291 20.7071C4.54129 20.9555 4.90178 21.0553 5.24256 20.9701L10.1201 19.7507C10.2888 19.7086 10.4435 19.6232 10.5691 19.5029L21.3957 9.13816L21.4113 9.12292C22.084 8.45028 22.4618 7.53798 22.4618 6.58673C22.4618 5.63547 22.084 4.72317 21.4113 4.05053C20.7387 3.37789 19.8264 3 18.8751 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddCommunity);
export default __webpack_public_path__ + "static/media/icon_add_community.12209b624f3ad24095520fcdd99d241f.svg";
export { ForwardRef as ReactComponent };